import { render, staticRenderFns } from "./TextList.vue?vue&type=template&id=22bf4548"
import script from "./TextList.vue?vue&type=script&lang=js"
export * from "./TextList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports